(function () {
    "use strict";

    var UserEditorControl = $app.defineClass(
        "SolovisGateway.Admin.Users.UserEditorControl",
        Solovis.UI.BaseControl,
        function (options) {
            this._userId = options.userId ? options.userId : null;
            this._isAdminUIRestricted = options.isAdminUIRestricted ? true : false;
            this._isEditMode = this._userId ? true : false;
            this._isDirty = false;
        }
    );

    UserEditorControl.prototype.doInitAsync = function () {
        var self = this;

        $app.Rpc.invoke("~/Admin/UserAdmin/GetEditUserDialogInitialState",
            { id: this._userId },
            function (response, success) {
                if (success) {
                    if (!response.result.userEditModel && self._userId) {
                        self._initErrorText = "Failed to retrieve user edit model.";
                    }
                    else {
                        self._userEditModel = response.result.userEditModel ? response.result.userEditModel : {};
                        self._organizations = response.result.organizations ? response.result.organizations : [];

                        self._userInInternalAdminOrganization = false;

                        let managingOrganization = self._userEditModel.managingOrganization;
                        if (managingOrganization) {
                            const eVestmentFirmGuid = managingOrganization.eVestmentFirmGuid;
                            const adminOrganizationGuid = self._userEditModel.adminOrganizationGuid;
                            if (eVestmentFirmGuid && adminOrganizationGuid) {
                                self._userInInternalAdminOrganization = eVestmentFirmGuid.toLocaleUpperCase() === adminOrganizationGuid.toLocaleUpperCase();
                            }
                        }
                    }
                    self.notifyInitComplete();
                }
                else {
                    self._initErrorText = response.error.message;
                    self.notifyInitComplete();
                }
            });
    };

    UserEditorControl.prototype.doDestroy = function () {

    };

    UserEditorControl.prototype.doRender = function () {
        var self = this;

        this.container
            .addClass("value-editor");

        if (this._initErrorText) {
            this.container.text(this._initErrorText);
            return;
        }

        var formDiv = $("<div>").appendTo(this.container);
        var formBuilder = new Solovis.UI.InputControls.FormBuilder({
            container: formDiv
        });

        // Full Name
        formBuilder.addEntry({
            name: "fullName",
            label: "Full Name",

            initialValue: this._userEditModel.fullName ? this._userEditModel.fullName : null,

            createEditor: function (createEditorOptions) {
                var editorControl = new Solovis.UI.InputControl({
                    container: createEditorOptions.container,
                    type: "text",
                    required: true,
                    readonly: self._isAdminUIRestricted,
                    max: 255,
                    width: 300,
                    value: createEditorOptions.initialValue,
                    validationModel: createEditorOptions.validationModel
                });

                return editorControl;
            }
        });

        // Primary Email
        const primaryEmailLabel = self._isAdminUIRestricted ? "eVestment Username" : "Primary Email";
        formBuilder.addEntry({
            name: "primaryEmail",
            label: primaryEmailLabel,

            initialValue: this._userEditModel.primaryEmail ? this._userEditModel.primaryEmail : null,

            createEditor: function (createEditorOptions) {
                var editorControl = new Solovis.UI.InputControl({
                    container: createEditorOptions.container,
                    type: "text",
                    required: true,
                    readonly: self._isAdminUIRestricted,
                    max: 255,
                    width: 300,
                    value: createEditorOptions.initialValue,
                    validationModel: createEditorOptions.validationModel
                });

                return editorControl;
            }
        });

        // Is Gateway Admin
        formBuilder.addEntry({
            name: "isGatewayAdmin",
            label: "Is Gateway Admin",

            initialValue: this._userEditModel.isGatewayAdmin ? this._userEditModel.isGatewayAdmin : null,

            editor: {
                type: "bool",
                checkBoxOptions: {
                    disabled: self._isAdminUIRestricted ? !self._userInInternalAdminOrganization : false,
                }
            },

            postSetup: function (formEntry) {
                formEntry.showEntry(self._isEditMode);
            }
        });

        // Is Login Disabled
        formBuilder.addEntry({
            name: "isLoginDisabled",
            label: "Is Login Disabled",

            initialValue: this._userEditModel.isLoginDisabled ? this._userEditModel.isLoginDisabled : null,

            editor: {
                type: "bool",
                checkBoxOptions: {
                    disabled: self._isAdminUIRestricted,
                }
            },

            postSetup: function (formEntry) {
                formEntry.showEntry(self._isEditMode);
            }
        });

        // Requre MFA
        formBuilder.addEntry({
            name: "requireMfa",
            label: "Is MFA Required",

            initialValue: this._userEditModel.requireMfa ? this._userEditModel.requireMfa : null,

            editor: {
                type: "bool"
            },

            postSetup: function (formEntry) {
                formEntry.showEntry(self._isAdminUIRestricted ? false : self._isEditMode);
            }
        });

        // Managing Organization
        formBuilder.addEntry({
            name: "managingOrganization",
            label: "Managing Organization",

            initialValue: this._userEditModel.managingOrganization ? this._userEditModel.managingOrganization.id : null,

            createEditor: function (createEditorOptions) {
                var organizationOptions = [{ text: "", value: null }];

                if (self._organizations.length) {
                    $(self._organizations).each(function (i, org) {
                        organizationOptions.push({
                            text: org.name,
                            value: org.id
                        });
                    });
                }


                var editorControl = new Solovis.UI.InputControl({
                    container: createEditorOptions.container,
                    type: "select",
                    data: organizationOptions,
                    value: createEditorOptions.initialValue,
                    readonly: self._isAdminUIRestricted
                });

                return editorControl;
            },

            postSetup: function (formEntry) {
                formEntry.showEntry(self._isEditMode);
            }
        });



        formBuilder.setupDone();

        $(formBuilder).bind("valueChanged", function () {
            self._isDirty = true;
        });

        this._formBuilder = formBuilder;
    };

    UserEditorControl.prototype._getUserModel = function () {
        var fullName = this._formBuilder.getValueByName("fullName");
        var primaryEmail = this._formBuilder.getValueByName("primaryEmail");
        var isGatewayAdmin = this._formBuilder.getValueByName("isGatewayAdmin");
        var isLoginDisabled = this._formBuilder.getValueByName("isLoginDisabled");
        var requireMfa = this._formBuilder.getValueByName("requireMfa");
        var managingOrganization = this._formBuilder.getValueByName("managingOrganization");

        var model = {
            fullName: fullName,
            primaryEmail: primaryEmail,
            isGatewayAdmin: isGatewayAdmin,
            isLoginDisabled: isLoginDisabled,
            requireMfa: requireMfa,
            managingOrganizationId: managingOrganization,
            id: this._userId

        };

        return model;
    };

    UserEditorControl.prototype.hideEditFields = function () {
        this._formBuilder.showEntries(false);
    };

    /*
     * options:
     * success -    true or false
     *              If success is true, this function assumes that a property called _savedDataEnvironmentEditorModel
     *              was set.  _savedDataEnvironmentEditorModel should contain the modelResult of the serverside save call.
     *              If success is false, then an error message should be provided.
     * message -    Error message to display on the form.
     */
    UserEditorControl.prototype.notify = function (options) {
        var self = this;

        if (options.success) {

            this.hideEditFields();

            var successHtml = $("<div>");

            var fullName = this._formBuilder.getValueByName("fullName");

            var userLink = $("<a>")
                .text(fullName)
                .attr("href", $app.resolveUrl("~/Admin/UserAdmin/Info/" + this._savedUserEditorModel.userId))
                .appendTo(successHtml);

            successHtml
                .prepend("User ")
                .append(" saved.");

            var state = {
                success: {
                    html: successHtml
                }
            };

            this._formBuilder.formValidationModel.state(state);
        }
        else {
            this._formBuilder.formValidationModel.setErrorMessage(options.message);
        }
    };


    UserEditorControl.prototype.isDirty = function () {
        return this._isDirty;
    };

    UserEditorControl.prototype.isValid = function () {
        return !this._formBuilder.hasErrors();
    };
})();